import TinyMCE from './TinyMCE'

export default TinyMCE